import { render, staticRenderFns } from "./classicUser.vue?vue&type=template&id=5ae7dd36&scoped=true&"
import script from "./classicUser.vue?vue&type=script&lang=js&"
export * from "./classicUser.vue?vue&type=script&lang=js&"
import style0 from "./classicUser.vue?vue&type=style&index=0&id=5ae7dd36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae7dd36",
  null
  
)

export default component.exports